"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mask = exports.LoadingIndicator = exports.Container = void 0;
var _react = require("@stitches/react");
var Container = exports.Container = (0, _react.styled)('div', {
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 9999,
  '&.visible': {
    display: 'block'
  },
  '&.hidden': {
    display: 'none'
  }
});
var Mask = exports.Mask = (0, _react.styled)('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  backgroundColor: 'white',
  filter: 'alpha(opacity=50)',
  opacity: '0.5'
});
var LoadingIndicator = exports.LoadingIndicator = (0, _react.styled)('div', {
  position: 'absolute',
  margin: '-74px -74px',
  width: 148,
  height: 148,
  top: '50%',
  left: '50%'
});
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');